import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Page from '../../layouts/Page'
import ChatContainer from '../../components/ChatBot/ChatContainer'
import Container from './Container'

const AiSearch = () => {
  const intl = useIntl();
  return (
    <Page
    title={<FormattedMessage id="ai_search" defaultMessage={"AI Search"} />}
    breadcrumbs={[
      {
        title: <FormattedMessage id="influencee" defaultMessage={"influencee"} />,
        link: "/"
      },
      {
        title: <FormattedMessage id="ai_search" defaultMessage={"AI Search"} />,
        link: "/ai-search"
      },
      
    ]}
    // description={<FormattedMessage id="ai_search_description" defaultMessage={"Write your goals and our AI will suggest the best creators for your brand"} />}
    description={intl.formatMessage({ id: "ai_search_description", defaultMessage: "Write your goals and our AI will suggest the best creators for your brand" })}
  >
    {/* <Container /> */}
   <div className='h-[calc(100vh-112px)]  py-3'>
   <Container />
   </div>

  </Page>
  )
}

export default AiSearch